<template>
    <div class="py-4">
        <div style="position: relative; overflow: auto;">
            <table v-if="!loading" class="w-100 border" style="position: relative;">
                <thead>
                    <th class="col-1 sticky">No.</th>
                    <th class="col-2 sticky">Vessel Name</th>
                    <th class="col-3 sticky">Vessel Type</th>
                    <th class="text-truncate">Type R & M</th>
                    <th class="text-truncate">Est Start Date</th>
                    <th class="text-truncate">Est End Date</th>
                    <th class="text-truncate">Est Total Days</th>
                    <th class="text-truncate">Actual Start Date</th>
                    <th class="text-truncate">Actual End Date</th>
                    <th class="text-truncate">Actual Total Days</th>
                    <th class="text-truncate">Est Cost Item</th>
                    <th class="text-truncate">Real Cost Item</th>
                    <th class="text-truncate">Equipment</th>
                    <th class="text-truncate">Work Item</th>
                    <th class="text-truncate">Done By</th>
                    <th class="text-truncate">PIC</th>
                </thead>
                <tbody>
                    <template v-if="dataReport.length">
                        <tr v-for="(item, index) in dataReport" :key="index">
                            <td class="col-1 bg-white sticky">{{ getRowNumber(index) }}</td>
                            <td class="col-2 bg-white sticky"><b-badge variant="success">{{ item.form.vehicle.name
                                    }}</b-badge>
                            </td>
                            <td class="col-3 sticky bg-white text-truncate">
                                {{ item.form?.vehicle?.vehicle_type?.name }}
                            </td>
                            <td class="text-truncate">
                                <div class="px-2 bg-danger" style="border-radius:4px">{{ item.task_type.name }}</div>
                            </td>
                            <td class="text-truncate">{{ formatDateTime(item?.start_at) }}
                            </td>
                            <td class="text-truncate">{{ formatDateTime(item?.estimated_finished_at)
                                }}
                            </td>
                            <td class="text-truncate text-center">{{
                                totalDays(item?.start_at, item?.estimated_finished_at) }} days</td>
                            <td class="text-truncate">{{ formatDateTime(item.actual_started_at) }}
                            </td>
                            <td class="text-truncate">{{ formatDateTime(item.actual_finished_at) }}
                            </td>
                            <td class="text-truncate text-center">{{
                                totalDays(item?.actual_started_at, item?.actual_finished_at) }} days</td>
                            <td class="text-truncate">{{ formatCurrency(item.cost_estimate) }}</td>
                            <td class="text-truncate">{{ formatCurrency(item.cost_real) }}</td>
                            <td class="text-truncate">{{ item.name == 'Others' ? item.other_name : item.name }}</td>
                            <td class="text-truncate">{{ item.title }}</td>
                            <td class="text-truncate">{{ findTextDoneBy(item.done_by) || '-' }}</td>
                            <td class="text-truncate">{{ item.form?.user_pic?.username || '-' }}</td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="11">
                                No Data Here
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <template v-else>
                <div class="w-100 d-flex justify-content-center my-5">
                    <b-spinner style="width: 64px; height:64px ;"></b-spinner>
                </div>
            </template>
        </div>
        <div v-if="dataReport.length" class="mt-4 d-flex align-items-center w-100 justify-content-end">
            <b-form-select plain v-model="meta.perPage" :options="limitOptions" style="width: 140px;"
                @input="fetchData"></b-form-select>
            <b-pagination class="mb-0 ml-3" @change="(page) => {
                meta.page = page
                fetchData()
            }" v-model="meta.page" :total-rows="meta.totalItems" :per-page="meta.perPage" first-number
                align="center"></b-pagination>
        </div>
    </div>
</template>
<script>
import moment from '@/node_modules/moment-timezone/index';
import { limitOptions } from '@/src/core/mock/data/optionsData';
import { srActions } from '@/src/Utils/helper';

export default {
    name: 'PlanAndEmergencyDetail',
    props: {
        params: null
    },
    data() {
        return {
            dataReport: [],
            limitOptions,
            meta: {
                page: 1,
                perPage: 10,
                totalItems: 10,
                totalPage: 1
            },
            loading: false,
            doneByOptions: [{ text: 'Internal Man Power', value: 'internal_man_power' }, { text: 'Sub Contractor', value: 'sub_contractor' }],
        }
    },
    methods: {
        ...srActions,
        async fetchData() {
            try {
                this.loading = true
                const body = {
                    vehicle_type_ids: this.params?.vehicle_type_ids?.map((item) => item?.id),
                    year: moment(this.params?.year).format('YYYY'),
                }
                const params = {
                    ...this.meta
                }
                const res = await this.fetchPlanEmergencyDetail({ body, params })
                const { data, meta } = res.data
                this.dataReport = data
                this.meta.page = meta.page
                this.meta.perPage = meta.per_page
                this.meta.totalItems = meta.total_item
                this.meta.totalPage = meta.total_pages

            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },
        getRowNumber(index) {
            return ((this.meta.page - 1) * this.meta.perPage) + (index + 1);
        },
        findTextDoneBy(value) {
            return this.doneByOptions.find((el) => el.value == value)?.text
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
            }).format(value)
        },
        totalDays(start_date, end_date) {
            if (start_date && end_date) {
                return moment(end_date).diff(start_date, 'days')
            } else {
                return '-'
            }
        },
        formatDateTime(value) {
            return value ? moment(value).format('DD MM YYYY HH:mm') : '-'
        }
    },
    mounted() {
        this.fetchData()
    },
}
</script>
<style scoped>
.sticky {
    position: sticky !important;
}

.col-1 {
    width: 20px !important;
    left: 0px;
}

.col-2 {
    min-width: 180px !important;
    left: 53px;
}

.col-3 {
    min-width: 140px !important;
    left: 233px;
}

table th {
    padding: 8px 12px;
}

table td {
    padding: 8px 12px;
    border-bottom: 1px solid;
}
</style>